import React from 'react';
import { QuizQuestionWut } from '../../../ui/quiz/quiz-question/quiz-question-wut';
import { useFieldAttributes } from '../../../services/field-attributes';
import { TextAreaInputWUT } from '../../../inputs/text-area-input-wut/text-area-input-wut';
import { FieldErrorWUT } from '../../../ui/field-error/field-error-wut';
import { FieldDescriptionWUT } from '../../../ui/field-description/field-description-wut';
export const QuizLongTextWUT = _ref => {
  let {
    id,
    target,
    label,
    hideLabel,
    placeholder,
    required = true,
    value,
    onChange,
    onFocus,
    onBlur,
    error,
    hasError = false,
    errorMessage,
    disabled = false,
    description,
    FieldLayout,
    requiredIndicatorType,
    requiredIndicatorPlacement,
    questionImage,
    questionImageAltText,
    questionImageResize,
    questionImageAlignment,
    questionImagePlacement
  } = _ref;
  const {
    labelId,
    inputId,
    errorId,
    descriptionId,
    ariaDescribedBy
  } = useFieldAttributes(id, error, description);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(QuizQuestionWut, {
      htmlFor: inputId,
      labelId: labelId,
      id: id,
      error: error,
      description: description,
      required: required,
      label: label,
      hideLabel: hideLabel,
      requiredIndicatorType: requiredIndicatorType,
      requiredIndicatorPlacement: requiredIndicatorPlacement,
      image: questionImage,
      imageAltText: questionImageAltText,
      imageResize: questionImageResize,
      imageAlignment: questionImageAlignment,
      imagePlacement: questionImagePlacement
    }),
    renderInput: () => /*#__PURE__*/React.createElement(TextAreaInputWUT, {
      label: label,
      placeholder: placeholder,
      required: required,
      value: value,
      onChange: onChange,
      onFocus: onFocus,
      onBlur: onBlur,
      disabled: disabled,
      inputId: inputId,
      hasError: hasError,
      ariaDescribedBy: ariaDescribedBy,
      fieldId: id
    }),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldErrorWUT, {
      target: target,
      hasError: hasError,
      errorMessage: errorMessage,
      id: errorId
    }), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    }))
  });
};
//# sourceMappingURL=quiz-long-text-wut.js.map